import { render } from "./notify-me.vue?vue&type=template&id=1b43297f"
import script from "./notify-me.vue?vue&type=script&lang=js"
export * from "./notify-me.vue?vue&type=script&lang=js"

import "./notify-me.vue?vue&type=style&index=0&id=1b43297f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__